var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        {
          class: {
            message: true,
            "message-quick-reply-on-the-right": _vm.isFromSubscriber,
          },
          style: _vm.messageStyles,
        },
        [
          _vm.textMessage.hasLinkPreview()
            ? _c("link-preview-card", { attrs: { message: _vm.textMessage } })
            : _vm._e(),
          _vm._v(" "),
          _c("div", { domProps: { innerHTML: _vm._s(_vm.sanitizedText) } }),
        ],
        1
      ),
      _vm._v(" "),
      _c("message-sender", { attrs: { message: _vm.message } }),
      _vm._v(" "),
      _vm.isDisplayingCheckboxes
        ? _c("select-message", { attrs: { message: _vm.message } })
        : _vm._e(),
      _vm._v(" "),
      _vm.isDisplayingButtons
        ? _c(
            "div",
            { class: _vm.buttonPanelClasses },
            _vm._l(_vm.buttons, function (button, index) {
              return _c("chatchamp-button", {
                key: index,
                attrs: { button: button, message: _vm.message },
              })
            }),
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }